import s from "styled-components";
import React, { forwardRef, memo } from "react";
import CheckmarkIcon from "_c/icon/Checkmark";
import PT from "prop-types";

export const CheckboxLabel = s.label`
  color: ${({ color, theme }) => color || theme.color.primary};
  opacity: ${({ isDisabled }) => (isDisabled ? 0.65 : 1)};
  display: inline-flex;
  margin-inline-end: 10px;
  align-items: center;
  cursor: pointer;
  user-select: none;
  strong {
    font-size: 16px;
    padding-top: 3px;
    margin-inline-start: 5px;
    font-weight: 500;
    color: var(--font-color-accent);
  }
`;
export const RealCheckbox = s.input.attrs({ type: "checkbox" })`
  opacity: 0;
  position: relative;
  :focus + span {
    box-shadow: ${({ theme, color }) =>
      `0px 0px 5px 2px ${color || theme.color.primary}`};
  }
  :checked + span {
    background-color: ${({ color, theme }) => color || theme.color.primary};
  }
  :checked + span svg {
    opacity: 1;
  }
  z-index: 2;
  cursor: pointer;
`;
export const FakeCheckbox = s.span`
  position: absolute;
  z-index: 0;
  left: 0;
  top: 0;
  width: 20px;
  height: 20px;
  border: ${({ color, theme }) =>
    "2px solid " + (color || theme.color.primary)};
  border-radius: 4px;
  background-color: transparent;
  transition: all .25s ease;
  svg {
    transition: opacity .25s ease, transform .25s ease;
    position: relative;
    top: -1px;
    left: 1px;
    opacity: 0;
  }
`;
export const ReversedCheckboxWrap = s.span`
  position: relative;
  margin-right: 7px;
`;
export const CheckboxWrap = s.span`
  position: relative;
  margin-left: 7px;
`;

const Checkbox = forwardRef((props, ref) => {
  return (
    <CheckboxLabel
      color={props.labelColor}
      htmlFor={props.id}
      title={props.title}
      className={props.className}
      isDisabled={props.disabled}
    >
      <ReversedCheckboxWrap>
        <RealCheckbox
          ref={ref}
          name={props.name}
          onBlur={props.onBlur}
          defaultChecked={props.defaultChecked}
          disabled={props.disabled}
          value={props.value}
          color={props.color}
          id={props.id}
          checked={props.checked}
          onChange={props.onChange}
        />
        <FakeCheckbox role="presentation" color={props.color}>
          <CheckmarkIcon width="14" color={props.iconColor} />
        </FakeCheckbox>
      </ReversedCheckboxWrap>
      <strong>{props.label}</strong>
    </CheckboxLabel>
  );
});
Checkbox.propTypes = {
  label: PT.string,
  onChange: PT.func,
  checked: PT.bool,
  defaultChecked: PT.bool,
  className: PT.string,
  title: PT.string,
  id: PT.string,
  color: PT.string,
  iconColor: PT.string,
  labelColor: PT.string,
  disabled: PT.bool,
};
Checkbox.defaultProps = {
  iconColor: "white",
};
Checkbox.displayName = "Checkbox";
export default memo(Checkbox);
